import { createComponent } from '@carvana/merch-components';

export const Main = createComponent('main', {
  className: 'mx-auto w-full bg-canvas-default'
});

export const Section = createComponent('section', {
  className: 'max-w-[1272px] -:mx-auto '
});

export const DisclaimerText = createComponent('p', {
  className:
    'mx-auto max-w-[1056px] px-2xl pb-6xl text-left text-text-default t-body-sm  sm:px-3xl sm:pb-8xl sm:t-body-md md:text-center'
});
